import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { changePhonenumber } from './thunks/changePhonenumber.thunk';
import { loadUser } from './thunks/loadUser.thunk';
import { loadUserSettings } from './thunks/loadUserSettings.thunk';
import { updateUserSettings } from './thunks/updateUserSettings.thunk';
import { getGeolocation } from 'store/records/thunks/getGeolocation.thunk';
import { enqueueSnackbar } from 'notistack';
import i18n from 'i18next';
import { updateUserActiveEmployer } from './thunks/updateUserActiveEmployer.thunk';
import { loadCurrentUserWorkTimeSaldoInformation } from './thunks/loadUserWorkTimeSaldoInformation.thunk';

export const workTimeSaldoItemsAdapter = createEntityAdapter({
  selectId: (workTimeSaldoItem) =>
    `${workTimeSaldoItem.PK}#${workTimeSaldoItem.date}`,
});

const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: {},
    settings: {},
    loading: true,
    userLoaded: false,
    settingsLoaded: false,
    isUpdatingActiveEmployer: false,
    workTimeSaldoItems: workTimeSaldoItemsAdapter.getInitialState(),
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(changePhonenumber.fulfilled, (state, action) => {
        // The response is `{ updated: <resourceCount> }`, so the new number is
        // only on the argument. Without this the number the session already
        // holds stays on screen until a reload.
        state.user.phone = action.meta.arg.phone;
      })
      .addCase(changePhonenumber.rejected, (state, action) => {
        // The verify step surfaces its own inline error; this is the
        // message that says what actually went wrong.
        enqueueSnackbar(i18n.t('notifications.errors.phone-change-rejected'), {
          variant: 'error',
          autoHideDuration: 8000,
        });
      })
      .addCase(loadUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadUser.fulfilled, (state, action) => {
        state.user = action.payload;

        state.loading = false;
        state.userLoaded = true;
      })
      .addCase(loadUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
        // No snackbar needed here
        // enqueueSnackbar(i18n.t('notifications.errors.get-user-rejected'), {
        //   variant: 'error',
        // });
      })
      .addCase(loadUserSettings.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadUserSettings.fulfilled, (state, action) => {
        state.settings = action.payload;

        state.loading = false;
        state.settingsLoaded = true;
      })
      .addCase(loadUserSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
        // No snackbar needed here
        // enqueueSnackbar(
        //   i18n.t('notifications.errors.get-user-settings-rejected'),
        //   {
        //     variant: 'error',
        //   }
        // );
      })
      .addCase(updateUserSettings.fulfilled, (state, action) => {
        state.settings = action.payload;
      })
      .addCase(updateUserActiveEmployer.pending, (state, action) => {
        state.isUpdatingActiveEmployer = true;
      })
      .addCase(updateUserActiveEmployer.fulfilled, (state, action) => {
        state.settings = action.payload;
        state.isUpdatingActiveEmployer = false;
      })
      .addCase(updateUserActiveEmployer.rejected, (state, action) => {
        state.isUpdatingActiveEmployer = false;
      })
      .addCase(getGeolocation.fulfilled, (state, action) => {
        console.log('getGeolocation fulfilled', action.payload);
        state.coordinates = action.payload;
      })
      .addCase(getGeolocation.pending, (state, action) => {
        console.log('location fetch started');
        state.coordinates = undefined;
        state.geolocationError = undefined;
      })
      .addCase(getGeolocation.rejected, (state, action) => {
        state.coordinates = undefined;
        console.log('rejected geolocation:', action.payload);
        state.geolocationError = action.payload;
      })
      .addCase(
        loadCurrentUserWorkTimeSaldoInformation.fulfilled,
        (state, action) => {
          const workTimeSaldoItems = action.payload?.workTimeSaldoItems;

          if (workTimeSaldoItems) {
            workTimeSaldoItemsAdapter.setMany(
              state.workTimeSaldoItems,
              workTimeSaldoItems
            );
          }
        }
      );
  },
});

export default userSlice.reducer;
